import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { GraficoComponenteProps } from "../../interfaces/dashboardCard";
import { useContext } from "react";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import "./modalGraficoCard.css"
import { Button } from "../Styles";
import GraficoColuna from "../GraficoColuna";

function ModalGraficoCard({ indicador }: GraficoComponenteProps) {
  const { modalExibir } = useContext(ModalEstadoContext)
  return (
    <div className="fundoModal">
      <section className='containerModalCentroGraficoCard'>
        <span id='novoContainerTitulo'>
          <BsFileEarmarkBarGraph className='adicionarModalIcone' title="Icone Indicador Mensuracao" />
          <p>Visualizar Dados</p>
        </span>
        <span className="sectionModalGraficoCard">
          <GraficoColuna indicador={indicador} />
        </span>
        <span className="botoesContainer">
          <Button type="button" cor="cancelar" isLoading={false} onClick={() => modalExibir("")}>
            Cancelar
          </Button>
        </span>
      </section>
    </div >
  );
}

export default ModalGraficoCard;